import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Navbar from "../../ReusableComponents/Navbar";
import { verifyEmailOtp, resendEmailOtp, verifyTotpLogin } from "../../Redux/APIs/mfa";
import * as AlertUtils from "../../Utils/alertUtils";
import * as LocalStorageUtils from "../../Utils/localStorageUtils";
import "./style.css";

const MfaVerify = () => {
  const history = useHistory();
  const location = useLocation();

  const { tempToken, mfaMethod } = location.state || {};

  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    if (!tempToken) {
      history.push("/login");
    }
  }, [tempToken, history]);

  useEffect(() => {
    if (cooldown <= 0) return;
    const timer = setTimeout(() => setCooldown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [cooldown]);

  const handleCodeChange = (e) => {
    setCode(e.target.value.replace(/\D/g, "").slice(0, 6));
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let response;
      if (mfaMethod === "totp") {
        response = await verifyTotpLogin(tempToken, code);
      } else {
        response = await verifyEmailOtp(tempToken, code);
      }
      LocalStorageUtils.SetAuthToken(response.data.webToken);
      history.push("/dashboard");
    } catch (err) {
      AlertUtils.ErrorAlert(err);
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    if (cooldown > 0) return;
    try {
      await resendEmailOtp(tempToken);
      setCooldown(60);
    } catch (err) {
      AlertUtils.ErrorAlert(err);
    }
  };

  if (!tempToken) return null;

  return (
    <>
      <Navbar loginPage noLoginButton />
      <div className="popup-page d-flex justify-content-center align-items-center">
        <form onSubmit={handleVerify} className="popup-box1 px-5">
          <h2 className="popup-heading mt-4 text-center">Verify Your Identity</h2>

          <p className="popup-para text-center px-3">
            {mfaMethod === "totp"
              ? "Enter the 6-digit code from your authenticator app."
              : "We've sent a 6-digit code to your email address."}
          </p>

          <div className="mfa-code-container mt-4">
            <input
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength={6}
              className="mfa-code-input"
              placeholder="------"
              value={code}
              onChange={handleCodeChange}
              autoFocus
            />
          </div>

          <button
            type="submit"
            disabled={code.length !== 6 || loading}
            className="popup-login-box popup-login-box-4 mt-4 d-flex justify-content-center align-items-center"
          >
            <p className="popup-login-box-text py-0 my-0">
              {loading ? "Verifying..." : "Verify"}
            </p>
          </button>

          {mfaMethod !== "totp" && (
            <div className="text-center mt-3 mb-4">
              <span
                className={`mfa-resend-link${cooldown > 0 ? " disabled" : ""}`}
                onClick={handleResend}
              >
                {cooldown > 0
                  ? `Didn't receive a code? Resend (${cooldown}s)`
                  : "Didn't receive a code? Resend"}
              </span>
            </div>
          )}

          <br />
        </form>
      </div>
    </>
  );
};

export default MfaVerify;
